import React, { useEffect, useState } from "react";
import { signInAsGuest, useAuth, logoutUser } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";

import Divider from "../layout/Divider.js";
import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { Skeleton } from "@mui/material";
import {
  createDoc,
  getDocDataById,
  getDocDataByRef,
  getOrgDataById,
  getRefFromId,
  listenDocDataById,
  updateDocDataField,
} from "../models/DataFunctions.js";
import { sendSmsVerificationCall } from "../config/ApiCalls.js";
import { gatherDeviceInfo } from "../config/GatheringInfos.js";
import { useSnackbar } from "notistack";
import TextField2 from "../textfields/TextField2.js";
import { VerifySmsCodeCall } from "../config/ApiCalls.js";
import { useAppContext } from "../config/AppContext.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import PDF from "../pdf/PDF.js";
import Modal1 from "../modals/Modal1.js";

import { getDocument } from "pdfjs-dist";

import { Spin } from "antd";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import paymentInitiationBridge from "../api/stripe/paymentInitiationBridge.js";
import paymentInitiationStripe from "../api/stripe/paymentInitiationStripe.js";
import downloadRapport from "../api/download/downloadRapport.js";

import moment from "moment";
import sendErrorPaiementEmail from "../api/send/sendErrorPaiementEmail.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import sendRequest from "../api/send/sendRequest.js";
import TextFieldEmail from "../textfields/TextFieldEmail.js";
import ParticulierHeader from "../modals/ParticulierHeader.js";
import { set } from "date-fns";
import { addActivityLog } from "../config/OnlineStatus.js";
import SmallSpinner from "../loading/SmallSpinner.js";
function Rapport({ navigateWorkspace, userData, impersonate = false }) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const [invoiceData, setInvoiceData] = useState(null);
  const [link_dead, setLink_dead] = useState(false);
  const [step, setStep] = useState(1);
  const [code, setCode] = useState("");
  const [sign_url, setSign_url] = useState("");
  const [masterData, setMasterData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [signal_open, setSignalOpen] = useState(false);
  const [message, SetMessage] = useState("");

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [conditions_open, setConditionsOpen] = useState(false);
  const { currentUser, loading } = useAuth();
  const [ipAddress, setIpAddress] = useState("");
  const [userAgent, setUserAgent] = useState("");

  const [paymentData, setPaymentData] = useState(null);
  const [folderData, setFolderData] = useState(null);
  const [payment_method, setPaymentMethod] = useState("bridge");
  const generateKey = async () => {
    const data = {
      creation_date: new Date(),
    };
    const key = await createDoc("security_key", data);
    return key.id;
  };

  useEffect(() => {
    const unsubscribe = listenDocDataById("payment", id, handleRefreshPayment);

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [id]);
  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    try {
      let payment = await getDocDataById("payment", id);
      let folder = await getDocDataByRef(payment.folder_ref);
      setFolderData(folder);

      // Check if user needs authentication
      const needsAuth = (!currentUser && !loading) || currentUser.email;

      // Check if guest user is authenticated for the wrong folder
      let wrongFolderAuth = false;
      if (currentUser && !currentUser.email && !impersonate) {
        // This is a guest user (format: guest-folder-{folder_id}---{uuid})
        const uidParts = currentUser.uid.split("-");
        if (uidParts.length >= 3 && uidParts[0] === "guest" && uidParts[1] === "folder") {
          const authenticatedFolderId = uidParts[2];
          if (authenticatedFolderId !== folder.id) {
            wrongFolderAuth = true;
          }
        }
      }

      if ((needsAuth || wrongFolderAuth) && impersonate === false) {
        if (wrongFolderAuth) {
          await logoutUser();
        }
        navigateWorkspace(
          "/smsportal/" +
            payment.folder_ref.id +
            "?auth_type=folder&redirect_url=rapport/" +
            id
        );
        return;
      }
      let master = await getOrgDataById(folder.master_id);
      if (folder.client_type !== "particulier") {
        let client = await getOrgDataById(folder.client_id);
        setClientData(client);
      }
      setMasterData(master);
      if (!payment) {
        setLink_dead(true);
      } else {
        if (payment.state === "error") {
          setLink_dead(true);
        } else if (payment.state === "paid") {
          setStep(4);
        } else {
          setConditionsOpen(true);
          setStep(3);
          setPaymentData(payment);

          await updateDocDataFieldApi(payment.ref, "state", "opened", prefix);
          await updateDocDataFieldApi(
            payment.ref,
            "opened_seconds",
            moment().unix(),
            prefix
          );
        }
      }

      // Fetch user data
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRefreshPayment = async (data) => {
    setPaymentData(data);
    if (data?.state === "paid") {
      setStep(4);
      setLoadingData(false);

      setPaymentDelayMessage(false);
    }
  };

  useEffect(() => {
    // Fetch the user's IP address
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://api64.ipify.org?format=json"); // A free IP address API
        const data = await response.json();
        setIpAddress(data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    // Set the user's user agent
    setUserAgent(navigator.userAgent);

    // Fetch IP address on component mount
    fetchIpAddress();
  }, []);

  const handleVerifyCode = async (event) => {
    event.preventDefault();
    try {
      let res = await VerifySmsCodeCall("payment", id, code, prefix);
      if (res.success) {
        handleClickVariant("Code SMS correct", "success"); // Success notification
        const data = {
          creation_date: new Date(),
        };
        await signInAsGuest(res.token);
        setStep(3);
        setConditionsOpen(true);
      } else {
        handleClickVariant("Code SMS incorrect", "error"); // Error notification
      }
    } catch (error) {
      handleClickVariant("Code SMS incorrect", "error"); // Error notification
      console.error("Error logging in:", error.message);
    }
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [loadingData, setLoadingData] = useState(false);

  const [signType, setSignType] = useState(0);
  const [signready, setSignReady] = useState(false);

  const setReady = () => {
    setSignReady(true);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.status === "success" && window.stripeCheckout) {
        // Close the Stripe window if it's still open
        window.stripeCheckout.close();
        setPaymentDelayMessage(true);
        setLoadingData(false);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const [payment_url, setPaymentUrl] = useState(null);
  const processPayment = async () => {
    await updateDocDataFieldApi(
      paymentData.ref,
      "type",
      payment_method,
      prefix
    );

    await addActivityLog(
      "Session de paiement ouverte",
      folderData?.ref,
      null,
      null,
      "payment_session_opened",
      prefix
    );
  };
  const [payment_delay_message, setPaymentDelayMessage] = useState(false);
  const handleOpenPayment = () => {
    const stripeWindow = window.open(payment_url, "_blank");
    if (stripeWindow) {
      window.stripeCheckout = stripeWindow;
    }
    setLoadingData(true);

    processPayment();
  };

  const handlePayment = async () => {
    await handleGenerateBridgePaymentLink();
  };

  const [pdf_open, setPDFOpen] = useState(null);

  const handleShowInvoice = async () => {
    setLoadingData(true);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(
      token,
      "facture",
      "",
      paymentData.folder_ref.id,
      prefix
    );
    let payment = await getDocDataByRef(paymentData.ref);
    setPDFOpen([payment.facture_file]);
    setLoadingData(false);
  };

  const handleDownload = async () => {
    setLoadingData(true);
    const token = await getOrRefreshFirebaseToken();
    let folder = await getDocDataByRef(paymentData.folder_ref);
    await getTemporaryUrl(token, "rapport-payment", "", folder.id, prefix);
    const payment = await getDocDataByRef(paymentData.ref);
    const files = payment.rapport_files;

    await addActivityLog(
      "Rapports téléchargés",
      folderData?.ref,
      null,
      null,
      "reports_downloaded",
      prefix
    );

    downloadRapport(files, folder.nom);
    setLoadingData(false);
    handleClickVariant("Rapports téléchargés", "success");
  };

  const handleGenerateBridgePaymentLink = async () => {
    setLoadingData(true);
    const token = await getOrRefreshFirebaseToken();
    let res = await paymentInitiationBridge(id, token, prefix);
    if (res.success) {
      setPaymentUrl(res.url);
      setPaymentMethod("bridge");
      setLoadingData(false);
    } else {
      handleClickVariant("Erreur lors de la génération du lien", "error");
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (loading === false) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [loading, id]); // Dependency array ensures this runs when currentUser changes

  if (!paymentData) {
    return <div></div>;
  }

  if (link_dead) {
    return (
      <div className="flex flex-col w-full h-full  overflow-auto align-middle items-center justify-center">
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="warning" fill="" />
          <div className="text-h2 text-center">Ce lien a expiré</div>
        </div>{" "}
      </div>
    );
  }

  return (
    <div
      className={`flex flex-col w-full h-full px-6  overflow-auto   flex-grow align-middle items-center justify-center`}
    >
      <Modal1 isOpen={conditions_open} onClose={() => setConditionsOpen(false)}>
        <div className="flex flex-col max-w-c600 w-full mx-10  h-fit ">
          <div className="flex flex-col justify-start items-start h-fit p-4  bg-white rounded-3xl shadow-xl   w-full  select-none ">
            <div className="flex flex-col gap-1 mb-2 w-full items-center">
              <div className="text-h2 text-center mb-2">
                Paiement sécurisé avec Bridge
              </div>{" "}
              <img
                src={masterData?.logo}
                className="w-c100 h-16 rounded-lg object-contain"
              />{" "}
            </div>

            <div
              className={` flex-col gap-1 text-h4  text-shadow_50 mt-2 text-start  w-full overflow-auto  scale-100 h-fit max-h-c100 sm:max-h-screen flex mt-4"
              }`}
            >
              Vous êtes sur une interface de paiement 100% sécurisée, propulsée
              par Hexagone, l’outil utilisé par votre prestataire pour la
              gestion et le suivi de votre intervention.
              <div className="mt-2">Informations de votre intervention </div>
              <ul className="flex flex-col gap-1 list-disc pl-8 my-2">
                <li> Prestataire : {masterData?.name}</li>{" "}
                <li>
                  Date de l’intervention :{" "}
                  {new Date(
                    folderData?.dateintervention?.seconds * 1000
                  ).toLocaleString()}
                </li>{" "}
                <li>
                  Adresse de l’intervention :{" "}
                  {folderData?.adresse +
                    " " +
                    folderData?.postal +
                    " " +
                    folderData?.ville}
                </li>{" "}
                <li>Nom du particulier : {folderData?.nom} </li>
                <li>
                  Email du particulier :{" "}
                  {paymentData.reglement_infos.email}{" "}
                </li>
                <li>
                  Téléphone du particulier :{" "}
                  {paymentData.reglement_infos.phone}{" "}
                </li>
              </ul>
              <div>
                Votre paiement est traité via Bridge, une plateforme de paiement
                sécurisée et reconnue mondialement.{" "}
              </div>
              <ul className="flex flex-col gap-1 list-disc pl-8 my-2">
                <li>
                  {" "}
                  ✅ Données protégées : Vos informations bancaires sont
                  chiffrées et ne sont jamais stockées sur nos serveurs.
                </li>
                <li>
                  ✅ Fiabilité garantie : Stripe est utilisé par des millions
                  d’entreprises à travers le monde.
                </li>
                <li>
                  ✅ Transparence totale : Consultez nos Conditions Générales
                  d’Utilisation et en savoir plus sur Hexagone sur notre site.
                </li>
              </ul>{" "}
            </div>
            <div className="w-full flex flex-row justify-center">
              <div
                className={`mt-4 max-w-c300 rounded-lg ${loadingData ? "bg-white text-black  " : "bg-black text-white w-full  shadow-md cursor-pointer hover:shadow-shadow_25 "}    flex justify-center  text-h2 px-4 py-2  font-semibold`}
                onClick={() => setConditionsOpen(false)}
              >
                Accepter
              </div>
            </div>
            <div className="text-h4 mt-4 text-shadow_50 text-center w-full ">
              {" "}
              En cliquant sur Accepter, vous confirmez votre transaction en
              toute sécurité et vous acceptez nos{" "}
              <span
                className="hover:text-black cursor-pointer"
                onClick={() =>
                  //open url
                  window.open(
                    "https://hexagone.expert/legal/conditions-utilisation#section"
                  )
                }
              >
                Conditions d'utilisation du service
              </span>{" "}
              et notre{" "}
              <span
                className="hover:text-black cursor-pointer"
                onClick={() =>
                  //open url
                  window.open(
                    "https://hexagone.expert/legal/confidentialite#section"
                  )
                }
              >
                Politique de confidentialité
              </span>
            </div>
            <div className="text-h4 mt-4 text-shadow_50 text-center w-full ">
              {" "}
              Sites des partenaires :{" "}
              <span
                className="hover:text-black cursor-pointer font-semibold text-indigo-500"
                onClick={() =>
                  //open url
                  window.open("https://www.hexagone.expert")
                }
              >
                hexagone
              </span>{" "}
              -{" "}
              <span
                className="hover:text-black cursor-pointer font-semibold text-indigo-500"
                onClick={() =>
                  //open url
                  window.open("https://www.bridgeapi.io/")
                }
              >
                Bridge
              </span>{" "}
            </div>
          </div>
        </div>
      </Modal1>
      <ParticulierHeader
        prefix={prefix}
        email={paymentData.reglement_infos.email}
        phone={paymentData.reglement_infos.phone}
      ></ParticulierHeader>
      {/* Left Column: Takes all available space */}

      {step === -1 && (
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="cloche" fill="" />
          <div className="text-h2 text-center">
            Votre partenaire a été notifié.
          </div>
          <div className="text-h2 text-shadow_50 text-center w-c250">
            Il va vous contacter pour récupérer le bon numéro de téléphone et
            relancer la procédure.
          </div>
          <div className="text-h2 text-shadow_50 text-center w-c250">
            Vous pouvez fermer cette page.
          </div>
        </div>
      )}

      <Modal1 isOpen={pdf_open} onClose={() => setPDFOpen(null)}>
        <div className="flex flex-col max-w-c900 w-full h-fit mx-4  bg-neutral-100 rounded-md p-2">
          <PDF
            defaultScale={isMobile ? 0.5 : 2}
            files={pdf_open}
            can_download={true}
            onClose={() => setPDFOpen(null)}
          ></PDF>
        </div>
      </Modal1>
      {step === 3 && paymentData && paymentData.state === "opened" && (
        <div className="flex flex-col h-fit p-4  bg-white rounded-3xl shadow-xl  items-center   w-full max-w-c350 ">
          <Icon1 icon_name="search" fill="" />
          <div className="text-h2 mt-4 text-center">Facture du paiement</div>
          <div className="flex mt-4 flex-row gap-2  w-full">
            <div
              className={`rounded-lg w-full transition-all ${loadingData ? "" : "border-2 border-shadow_10 cursor-pointer hover:border-blue-200 shadow-md text-shadow_50 duration-300 hover:shadow-shadow_25"}    flex justify-center bg-white text-h2 px-3 py-1  `}
              onClick={handleShowInvoice}
            >
              {loadingData ? <SmallSpinner /> : <> Voir la facture </>}
            </div>
          </div>
          {!loadingData && (
            <div
              className={`mt-4 rounded-lg ${loadingData ? "bg-white text-black  " : "bg-black text-white w-full  shadow-md cursor-pointer hover:shadow-shadow_25 "}    flex justify-center  text-h2 px-4 py-2  font-semibold`}
              onClick={() => {
                setStep(4);
                handlePayment();
              }}
            >
              Continuer
            </div>
          )}

          <div className="text-h4 mt-4 text-shadow_50 text-center w-full ">
            {" "}
            En passant votre commande, vous acceptez nos{" "}
            <span
              className="hover:text-black cursor-pointer"
              onClick={() =>
                //open url
                window.open(
                  "https://hexagone.expert/legal/conditions-utilisation#section"
                )
              }
            >
              Conditions d'utilisation du service
            </span>{" "}
            et notre{" "}
            <span
              className="hover:text-black cursor-pointer"
              onClick={() =>
                //open url
                window.open(
                  "https://hexagone.expert/legal/confidentialite#section"
                )
              }
            >
              Politique de confidentialité
            </span>
          </div>
        </div>
      )}
      {step === 4 && payment_delay_message && (
        <div className="flex flex-col w-fit h-fit p-4  bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="horloge" fill="grey" />
          <div className="text-h3 text-center w-c300 mt-2">
            Le paiement est en cours de traitement.
          </div>

          <div className="text-h4 text-center w-c300 text-shadow_50 mt-4">
            Vous serez notifié par email dès que le paiement sera validé.
          </div>
        </div>
      )}
      {step === 4 &&
        paymentData &&
        !payment_delay_message &&
        paymentData.state === "opened" && (
          <div className="flex flex-col h-fit p-4  bg-white rounded-3xl shadow-xl  items-center m-4 w-full max-w-c350 select-none ">
            <Icon1 icon_name="smartphone" fill="" />
            <div className="text-h2 mt-4 text-center">Moyen de paiement</div>
            <div className="flex mt-4 flex-row justify-center gap-2 w-full ">
              {false && (
                <div
                  className={`rounded-lg   transition-all border-2 ${payment_method === "card" && loadingData ? "  border-blue-300" : payment_method === "card" ? "  border-blue-300 " : loadingData ? "border-shadow_10  cursor-default  text-shadow_50" : "border-shadow_10 cursor-pointer hover:border-blue-200 text-shadow_50 hover:shadow-shadow_25"} duration-300 hover:shadow-shadow_25 flex justify-center bg-white text-h2 px-3 py-1 shadow-md `}
                  onClick={() => !loadingData && setPaymentMethod("card")}
                >
                  Carte bancaire
                </div>
              )}

              <div
                className={`rounded-lg   transition-all border-2 ${payment_method === "bridge" && loadingData ? "  border-blue-300" : payment_method === "bridge" ? "  border-blue-300 " : loadingData ? "border-shadow_10  cursor-default  text-shadow_50" : "border-shadow_10 cursor-pointer hover:border-blue-200 text-shadow_50 hover:shadow-shadow_25"} duration-300 hover:shadow-shadow_25 flex justify-center bg-white text-h2 px-3 py-1 shadow-md `}
                onClick={() => {
                  !loadingData && setPaymentMethod("bridge");
                }}
              >
                Virement bancaire
              </div>
            </div>
            <div className="text-h3 mt-4 text-center text-shadow_50">
              Réception{" "}
              <span className=" ">
                {payment_method === "card" || masterData?.compteurs.auto_sepa
                  ? "instantanée"
                  : "variable"}
              </span>
            </div>

            <div>
              <BoldBlackButton
                onClick={handleOpenPayment}
                loading={loadingData}
                disabled={payment_url === null}
                ability_loading={loadingData === false && payment_url === null}
              >
                {loadingData ? (
                  <div className="flex flex-col gap-2">
                    <SmallSpinner />

                    <div
                      className="text-h4 mt-4 text-shadow_50 text-center w-full hover:text-black cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        setLoadingData(false);
                        setStep(3);
                      }}
                    >
                      Annuler le traitement
                    </div>
                  </div>
                ) : (
                  <>Payer</>
                )}
              </BoldBlackButton>
            </div>

            <div className="text-h4 mt-4 text-shadow_50 text-center w-full ">
              {" "}
              En passant votre commande, vous acceptez nos{" "}
              <span
                className="hover:text-black cursor-pointer"
                onClick={() =>
                  //open url
                  window.open(
                    "https://hexagone.expert/legal/conditions-utilisation#section"
                  )
                }
              >
                Conditions d'utilisation du service
              </span>{" "}
              et notre{" "}
              <span
                className="hover:text-black cursor-pointer"
                onClick={() =>
                  //open url
                  window.open(
                    "https://hexagone.expert/legal/confidentialite#section"
                  )
                }
              >
                Politique de confidentialité
              </span>
            </div>
          </div>
        )}
      {step === 4 && paymentData && paymentData.state === "pending" && (
        <div className="flex flex-col w-fit h-fit p-4 gap-2 bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="horloge" fill="" />
          <div className="text-h3 text-center w-c300">
            Le paiement est en cours de traitement.
          </div>
          <div className="text-h4 text-center w-c300 text-shadow_50">
            Vous recevrez un email de confirmation dès que le paiement sera
            validé.
          </div>
        </div>
      )}
      {step === 4 && paymentData && paymentData.state === "paid" && (
        <div className="flex flex-col w-fit h-fit p-4  bg-white rounded-3xl shadow-xl overflow-auto items-center">
          <Icon1 icon_name="done2" fill="#4dffa6" />
          <div className="text-h3 text-center w-c300 mt-2">
            Le paiement a été validé.
          </div>
          {paymentData.rapport_files?.length > 0 && (
            <>
              {folderData?.client_type === "particulier" &&
                paymentData.rapport_files?.length > 0 && (
                  <>
                    <div
                      className={`mt-3 rounded-lg ${loadingData ? "bg-white text-black  " : "bg-black text-white w-c300 shadow-md cursor-pointer hover:shadow-shadow_25 "}    flex justify-center  text-h2 px-4 py-2  font-semibold`}
                      onClick={handleDownload}
                    >
                      {loadingData ? <SmallSpinner /> : <>Télécharger</>}
                    </div>{" "}
                    <div className="text-h4 text-center w-c300 text-shadow_50 mt-4">
                      Vous allez recevoir un email de confirmation
                      prochainement.
                    </div>
                  </>
                )}
              {folderData?.client_type === "particulier" &&
                paymentData.rapport_files?.length === 0 && (
                  <>
                    <div
                      className={`mt-3 rounded-lg bg-neutral-300 text-neutral-500 w-c300  hover:shadow-shadow_25   flex justify-center  text-h2 px-4 py-2  font-semibold`}
                    >
                      Aucun rapport à télécharger
                    </div>{" "}
                    <div className="text-h4 text-center w-c300 text-shadow_50 mt-4">
                      Le bureau de contrôle n'a pas encore déposé de rapport
                      pour ce paiement.
                    </div>
                  </>
                )}
              {folderData?.client_type === "architect" && (
                <>
                  <div className="flex flex-row  w-full gap-3 items-center text-h4 text-center justify-center text-shadow_50 mt-4">
                    <div className="w-c100 text-right">{masterData?.name}</div>
                    <div className="flex flex-row  ">
                      <Icon1 icon_name="right" fill="grey" size={10}></Icon1>
                      <Icon1 icon_name="right" fill="black" size={10}></Icon1>
                      <Icon1 icon_name="right" fill="grey" size={10}></Icon1>
                    </div>

                    <div className="w-c100 text-left">{clientData?.name}</div>
                  </div>

                  <div className="text-h4 text-center w-c300 text-shadow_50 mt-4">
                    Les rapports ont été transmis. Vous devez vous rapprocher de{" "}
                    {clientData?.name} pour les récupérer.
                  </div>
                </>
              )}
            </>
          )}
          {!(paymentData.rapport_files?.length > 0) && (
            <div className="flex flex-col gap-2">
              <div className="text-h4 text-center w-c300 text-shadow_50 mt-4">
                Aucun rapport n'a été déposé pour ce paiement.
              </div>
              <div className="text-h4 text-center w-c300 text-shadow_50 mt-4">
                Vous serez notifié par email dès qu'ils seront disponibles.
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Rapport;

export const BoldBlackButton = ({
  onClick,
  children,
  disabled = false,
  ability_loading = false,
  loading = false,
}) => {
  return (
    <div
      className={`mt-4 rounded-lg ${loading ? "bg-white text-black" : disabled ? "bg-gray-300 text-gray-400" : "bg-black text-white hover:shadow-shadow_25 shadow-md cursor-pointer"}  w-full  max-w-c200    flex justify-center  text-h2 px-4 py-2  font-semibold`}
      onClick={(e) => !disabled && onClick(e)}
    >
      {ability_loading ? <SmallSpinner /> : children}
    </div>
  );
};
